<template>
	<section :class="{ 'module allocation-breakdown-table': props.setBorder }">
		<div v-if="!props.setBorder">
			<div class="display-flex justify-content-space-between">
				<h4 class="subheading mb-50">{{ props.tableHeading }}</h4>
				<BaseCtaLink v-if="ctaLink" :link="ctaLink" icon="arrow-bold" text="Learn more" />
			</div>
		</div>
		<h4 v-else class="heading-6 mb-50">{{ props.tableHeading }}</h4>

		<div
			v-for="(allocation, index) in props.allocations"
			:key="index"
			class="epsilon display-flex justify-content-space-between py-100"
			:class="{ bt: index !== 0, bb: index === props.allocations.length - 1 && !props.setBorder }"
		>
			<span class="text-color-content-secondary">{{ allocation.allocation }}</span>
			<div class="display-flex align-items-center">
				<AllocationBreakdownWheel :percentage="percentage(allocation.percentage)" />
				<span
					class="font-weight-bold ml-50"
					:class="{ 'mr-50': isPercentageSingleDigit(big(allocation.percentage)) }"
				>
					{{ percentage(allocation.percentage, true) }}</span
				>
			</div>
		</div>
		<div v-if="props.ctaLink && props.setBorder" class="bt">
			<div class="mt-150 mb-50 text-align-right">
				<BaseCtaLink :link="props.ctaLink" text="Learn more" />
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import AllocationBreakdownWheel from '@components/offering-details/allocation-breakdown-wheel.vue';
import big from 'big.js';
import { Link } from 'types/layout';
import { percentage } from '@filters/shared-filters';
import { PercentageAllocation } from 'types/reit-details';

interface Props {
	tableHeading: string;
	allocations: Array<PercentageAllocation>;
	ctaLink?: Link;
	setBorder?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	ctaLink: undefined,
	setBorder: true
});

function isPercentageSingleDigit(percent: big): boolean {
	return big(percent).lt(0.1);
}
</script>
<style lang="scss">
@use '../../styles/constants/colors.scss' as *;

.allocation-breakdown-table {
	padding: 1.5rem;
	border: 1px solid token('bg-tertiary');
	border-radius: 8px;
	box-shadow: none;
}
</style>
